import React, {Component} from 'react';
import {
    Grid,
    Divider,
    Typography,
    Paper,
    Table,
    TableBody
} from 'material-ui';
import {showAddGlobalButton} from '../../../components/permissions/permissions';
import {downloadCSV} from '../../../components/helpers/helpers';
import DropzoneDocumentField from '../../../components/fields/field_dropzone_document_csv';
import {Heading} from '../../../components/heading/heading';
import ErrorsTableItems from './ErrorsTableItems';
import ErrorsTableHeader from './ErrorsTableHeader';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';

class AddBulkRedirectsForm extends Component {

    render() {
        const {
            bulkDocument,
            bulkUploadErrors,
            onUpdateDocumentField,
            onDeleteDocumentField,
            handleSubmit,
            touched,
            classes,
            loading
        } = this.props;

        let hasDoc = Object.keys(bulkDocument).length !== 0;
        let headers = [{redirect_from: '', redirect_to: '', status: '', site_id: ''}];

        return (
            <span>
                <Heading
                    title={'Upload Bulk Redirects'}
                    buttonTitle={'Download empty .csv file'}
                    buttonAction={() => downloadCSV(headers)}
                    showButton={showAddGlobalButton}
                />
                <Grid container>
                    <Grid item xs={12}>
                        <DropzoneDocumentField
                            multiple={false}
                            document={bulkDocument}
                            onDocumentDelete={() => {
                                onDeleteDocumentField();
                            }}
                            onDocumentDrop={(document) => {
                                onUpdateDocumentField(document);
                            }}
                        />
                    </Grid>
                    {bulkUploadErrors.length > 0 && 
                        <Grid item xs={12}>
                            <Divider />
                            <Typography variant="subheading" className={classes.errorsTitle}>Please correct the following errors and upload a new .csv file with the correct redirects!</Typography>
                            <Paper className={classes.rootErrorsTable}>
                                <Table className={classes.errorsTable}>
                                    <ErrorsTableHeader
                                        classes={classes}
                                    />
                                    <TableBody>
                                        {bulkUploadErrors.map((error, index) =>
                                            <ErrorsTableItems
                                                key={index}
                                                error={error}
                                                classes={classes}
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Grid>
                    }
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={!touched || loading || !hasDoc}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                            onClick={(e) => handleSubmit(bulkDocument)}
                        />
                        <BackButton
                            link={"/redirects"}
                            style={{marginRight: 15 }}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </span>
        )
    }
}

export default AddBulkRedirectsForm;


// WEBPACK FOOTER //
// ./src/containers/redirects/forms/AddBulkRedirectsForm.jsx